import { render, staticRenderFns } from "./CarouselP.vue?vue&type=template&id=ab0144ba&scoped=true&"
import script from "./CarouselP.vue?vue&type=script&lang=js&"
export * from "./CarouselP.vue?vue&type=script&lang=js&"
import style0 from "./CarouselP.vue?vue&type=style&index=0&id=ab0144ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0144ba",
  null
  
)

export default component.exports